// src/pages/Reports/ReserveSurplusLedger/reserveSurplusLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchReserveSurplusLedger, fetchReserveSurplusAccounts } from "./reserveSurplusLedgerThunk";
import dayjs from "dayjs";
import { currentDateStartTime, currentDateEndTime } from "../../../lib/functions";

const today = dayjs().startOf("day");

const initialState = {
  filters: {
    account: null,
    fromDate: currentDateStartTime(today),
    toDate: currentDateEndTime(today),
  },
  accounts: [],
  data: [],
  openingBalance: 0,
  closingBalance: 0,
  loading: false,
  error: null,
};

const reserveSurplusLedgerSlice = createSlice({
  name: "reserveSurplusLedger",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Accounts search
      .addCase(fetchReserveSurplusAccounts.fulfilled, (state, action) => {
        state.accounts = action.payload || [];
      })
      // 🔹 Report fetch
      .addCase(fetchReserveSurplusLedger.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReserveSurplusLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.ledger || [];
        state.openingBalance = action.payload.opening_balance || 0;
        state.closingBalance = action.payload.closing_balance || 0;
      })
      .addCase(fetchReserveSurplusLedger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching Reserve & Surplus Ledger";
      });
  },
});

export const { setFilters } = reserveSurplusLedgerSlice.actions;
export default reserveSurplusLedgerSlice.reducer;
